import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";

// Live prices via backend WebSocket relay (Binance stream), with REST polling fallback.
export function usePrices() {
  const [prices, setPrices] = useState({});
  const [live, setLive] = useState(false);
  const pollRef = useRef(null);

  useEffect(() => {
    let ws;
    let stopped = false;

    const applyTickers = (arr) => {
      setPrices((prev) => {
        const next = { ...prev };
        for (const t of arr) next[t.symbol] = t;
        return next;
      });
    };

    const startPolling = () => {
      if (pollRef.current) return;
      const tick = async () => {
        try {
          const r = await fetch(`${API}/market/tickers`);
          if (r.ok) applyTickers(await r.json());
        } catch (e) { /* retry next tick */ }
      };
      tick();
      pollRef.current = setInterval(tick, 5000);
    };

    const connect = () => {
      if (stopped) return;
      const wsUrl = `${API.replace(/^http/, "ws")}/ws/prices`;
      try {
        ws = new WebSocket(wsUrl);
      } catch (e) {
        startPolling();
        return;
      }
      ws.onopen = () => setLive(true);
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg.type === "snapshot") applyTickers(msg.data);
          else if (msg.type === "ticker") applyTickers([msg.data]);
        } catch (e) { /* ignore */ }
      };
      ws.onerror = () => { try { ws.close(); } catch (e) {} };
      ws.onclose = () => {
        setLive(false);
        if (!stopped) {
          startPolling();
          setTimeout(connect, 8000);
        }
      };
    };

    connect();
    return () => {
      stopped = true;
      if (pollRef.current) clearInterval(pollRef.current);
      if (ws) try { ws.close(); } catch (e) {}
    };
  }, []);

  return { prices, live };
}
